import React from "react";
import { motion } from "framer-motion";
import { CheckIcon, SparklesIcon, StarIcon } from "lucide-react";
import { CTAButton, TrustBadges } from "./ui";
import { heroMockup } from "./data";
const chips = ["100% PDF", "6 Tomos", "3 Bonos incluidos"];
export function Hero() {
  return <header className="relative w-full overflow-hidden bg-[#f5f9ff] pt-6" data-id="element-117" data-mp="4m8nyh6uizn1">
      <div className="pointer-events-none absolute -left-24 top-24 h-52 w-52 rounded-full bg-[#d9e9ff] blur-3xl" data-id="element-118" data-mp="4jvyzk2o7p0h" />
      <div className="pointer-events-none absolute -right-24 top-1/3 h-56 w-56 rounded-full bg-[#ddf3e4] blur-3xl" data-id="element-119" data-mp="xanpq20yvlgf" />

      <div className="relative mx-auto flex max-w-xl flex-col items-center px-4 pb-9 text-center sm:px-8 sm:pb-20" data-id="element-120" data-mp="sai5h6x1118d">
        <motion.div initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.45
      }} className="inline-flex items-center gap-2 rounded-full border border-[#d8e8ff] bg-white px-4 py-2 text-[11px] font-extrabold uppercase tracking-[0.12em] text-[var(--accent)] shadow-sm" data-id="element-121" data-mp="nbexbdlr2ew6">
          <SparklesIcon className="h-3.5 w-3.5" aria-hidden data-id="element-122" data-mp="3o7lrboupx2nw" />
          Pequeños Pasos, Grandes Logros™
        </motion.div>

        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.05
      }} className="mt-4 font-serif-display text-[2rem] font-semibold leading-[1.05] tracking-[-0.03em] text-[var(--ink)] sm:text-5xl" data-id="element-123" data-mp="39autvl4lu10x">
          Menos crisis. <span className="text-[var(--accent)]" data-id="element-124" data-mp="359syjfdt6948">Más calma</span> en casa.
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.12
      }} className="mt-3 max-w-md text-sm leading-relaxed text-[var(--muted)] sm:mt-5 sm:text-lg" data-id="element-125" data-mp="2qkwk90l5rzv6">
          Dejá de sentir que cada día es empezar de cero. Encontrá un plan claro para comprender, acompañar y construir rutinas que funcionen para tu hijo con TDAH o Autismo.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        scale: 0.96,
        y: 16
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} transition={{
        duration: 0.65,
        delay: 0.18,
        ease: [0.22, 1, 0.36, 1]
      }} className="relative mt-5 w-full max-w-[220px] sm:mt-7 sm:max-w-[290px]" data-id="element-126" data-mp="nbbc4wdi0748">
          <div className="absolute inset-x-8 bottom-3 h-12 rounded-full bg-[#296fe8]/25 blur-2xl" data-id="element-127" data-mp="1b0vvvhhh78ek" />
          <motion.img src={heroMockup} alt="Mega Biblioteca para TDAH y Autismo Infantil: más de 6 tomos prácticos" className="relative mx-auto w-full rounded-[1.5rem] border-4 border-white object-contain shadow-[0_24px_55px_-24px_rgba(31,51,69,0.58)]" animate={{
          y: [0, -6, 0]
        }} transition={{
          duration: 5,
          repeat: Infinity,
          ease: "easeInOut"
        }} loading="eager" data-id="element-128" data-mp="161t1cqz4gkku" />
          <div className="absolute -right-5 top-8 rounded-2xl bg-[#ffca49] px-3 py-2 text-left text-[10px] font-extrabold leading-tight text-[#55400b] shadow-lg" data-id="element-129" data-mp="3hqkb0idnhstd">
            <span className="block" data-id="element-130" data-mp="21amuv6fipmkr">6 tomos</span>
            <span className="block" data-id="element-131" data-mp="21bfy3xf9pty5">+ 3 bonos</span>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.55,
        delay: 0.25
      }} className="mt-5 w-full sm:mt-8" data-id="element-132" data-mp="2697noksfx3z6">
          <CTAButton data-id="element-133" data-mp="2fzarzh50i4ct">Quiero empezar hoy</CTAButton>
          <p className="mt-3 text-xs font-semibold text-[var(--muted)]" data-id="element-134" data-mp="2kyduouxiryhm">
            Acceso inmediato · Pago único · Sin suscripción
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.34
      }} className="mt-4 flex items-center gap-2 sm:mt-6" data-id="element-135" data-mp="2oynzw5dhmkvf">
          <div className="flex text-[#f3ae22]" data-id="element-136" data-mp="zlauectn2qsq">
            {Array.from({
            length: 5
          }).map((_, i) => <StarIcon key={i} className="h-4 w-4 fill-current" aria-hidden data-id="element-137" data-mp="4aupet2693ou" data-mpi={i} />)}
          </div>
          <span className="text-sm font-bold text-[var(--ink)]" data-id="element-138" data-mp="3vignm664gdyb">Más de 500 familias</span>
        </motion.div>

        <div className="mt-4 flex flex-wrap justify-center gap-1.5 sm:mt-5 sm:gap-2" data-id="element-139" data-mp="e8innsyzktbr">
          {chips.map(c => <span key={c} className="flex items-center gap-1.5 rounded-full border border-[#dbe8f8] bg-white px-3 py-1.5 text-xs font-bold text-[var(--ink)] shadow-sm" data-id="element-140" data-mp="9b0afqdxrrxy">
              <CheckIcon className="h-3.5 w-3.5 text-[var(--accent-green)]" aria-hidden data-id="element-141" data-mp="3crz14jbvuele" />
              {c}
            </span>)}
        </div>

        <TrustBadges className="mt-4 max-w-sm sm:mt-6" compact data-id="element-142" data-mp="3rhwst990tmfc" />
      </div>
    </header>;
}